import { useGetCounries } from "@/actions/hooks/useGetCountries.tsx";
import { CountrySelectProps } from "@/components/Inputs/CountrySelect/CountrySelectProps.ts";
import { requiredRule } from "@/helpers/form/FormRules.ts";
import { useTranslation } from "react-i18next";

import { ChevronDown } from "@/components/Icons/utility/ChevronDown.tsx";
import { useGetOrganization } from "@/helpers/useGetOrganization.ts";
import { useEffect, useMemo } from "react";

export const CountrySelect = (props: CountrySelectProps) => {
  const { t } = useTranslation();
  const { organizationName } = useGetOrganization();
  const { countries, getCountriesLoading } = useGetCounries();
  const { name } = props;

  useEffect(() => {
    if (!props.watch?.(name)) {
      if (organizationName === "Campuccino") {
        props.setValue?.(name, "DEU");
      } else {
        props.setValue?.(name, "HRV");
      }
    }

    if (countries.length && props.watch?.(name)) {
      // makes validation trigger/work on persistation
      setTimeout(async () => props.trigger?.(name));
    }
    // dependency array is valid
    // eslint-disable-next-line
  }, [countries, props.watch?.(name)]);

  const sortedCountries = useMemo(() => {
    if (!countries.length) return [];
    const croatia = countries.find((country) => country.iso3Code === "HRV")!;
    const otherCountries = countries.filter((country) => country.iso3Code !== "HRV");
    return [croatia, ...otherCountries];
  }, [countries]);

  return (
    <div className="c-be-select-wrapper">
      <label className="c-be-select-label" htmlFor={name}>
        {t(name)} {props.isMandatory ? " *" : ""}
      </label>
      <div className="c-be-select-wrapper__inner">
        <select
          disabled={getCountriesLoading}
          className="c-be-select"
          id="countrySelect"
          {...props.register?.(name, requiredRule)}
          value={props.watch?.(name) as string}
        >
          {sortedCountries?.map((country) => {
            return (
              <option key={country.iso3Code} value={country.iso3Code}>
                {country.name}
              </option>
            );
          })}
        </select>
        <ChevronDown />
      </div>
    </div>
  );
};
